import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSourcingCampaignStatusFilter } from './useSourcingCampaignStatusFilter';

export const SourcingCampaignStatusFilter = ({ value, setFilters, title }) => {
  const { formSchema, onSubmit, sourcingCampaignStatusOptions } = useSourcingCampaignStatusFilter({
    setFilters,
  });

  // Transform value to array format
  const selectedOptions = React.useMemo(() => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return [];
    }

    // Handle both array and single string values
    const valuesArray = Array.isArray(value) ? value : [value];

    // Map values to options, preserving empty strings (which represent "not boosted")
    const mapped = valuesArray
      .map((val) => {
        // Empty string is a valid value for "Not boosted"
        if (val === '') {
          return sourcingCampaignStatusOptions.find((option) => option.label === 'Not boosted');
        }
        return sourcingCampaignStatusOptions.find((option) => option.value === val);
      })
      .filter(Boolean);

    // Remove duplicates (in case both "Any" and "Not boosted" are selected, they both have value '')
    const seen = new Set();
    return mapped.filter((option) => {
      const key = `${option.value}-${option.label}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }, [value, sourcingCampaignStatusOptions]);

  return (
    <Formik
      initialValues={{ sourcingCampaignStatus: selectedOptions }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="sourcingCampaignStatus"
          placeholder={title}
          size="small"
          component={FormMultiSelect}
          options={sourcingCampaignStatusOptions}
          anchorToBody
          isSearchable={false}
        />
      </Form>
    </Formik>
  );
};

SourcingCampaignStatusFilter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.oneOf([null])]),
  setFilters: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

SourcingCampaignStatusFilter.defaultProps = {
  value: null,
};
